import React from 'react'
import styled from '@emotion/styled'
import { getLoginUrl } from '../../utils/auth'
import Link from '../shared/link'

const Container = styled.p`
  margin: 0;
  font-size: ${p => p.theme.fontSizes[1]};
`

const Login = ({ className, next }) => (
  <Container className={className}>
    Already a user?{' '}
    <Link variant="fill" to={getLoginUrl(next)}>
      Log in
    </Link>
  </Container>
)

export default Login
